import { isAtoZDomain } from "@amzn/ato-zhvh-app-common-util";

export const isDragonstone = (requisitionId: string) => {
  return requisitionId.toLowerCase().startsWith("job");
};

export const isSalesforceApplication = (applicationId: string) => {
  return applicationId.length != 36 && applicationId.startsWith("a"); //Salesforce application id starts with a for auto-generated ids
};

export const generateCurrentUrlForRedirectUrl = () => {
  // TODO: encoding url is causing errors on AtoZ, to be investigated
  return isAtoZDomain() ? "" : encodeURIComponent(window.location.href);
};
